import {ImportNissanPriceListResult} from './ImportNissanPriceListResultSchema';

export type ImportNissanPriceListUseCaseResult = {
  result: ImportNissanPriceListResult;
};
